/**
 * drawerRegistry.js — component bindings for each drawer key.
 *
 * Schema (arg names + types) lives in `drawerSchema.js` so the parser path
 * (parser → layerNav → SiteDetails → would-have-pulled-everything-in) stays
 * lightweight. This file is imported ONLY by DrawerStack.vue at mount time;
 * never by the parser, the helpers, or any drawer-content component.
 *
 * Registered in XOL-209 PR 2:
 *   site     — full SiteDetailLayer (legacy /sites/site/:id)
 *   siteUtil — SiteUtilTable (legacy /utility/:utilityId — a site's bill list)
 *   bill     — SiteUtilBillDetail (legacy /utility/:utilityId/bill/:billId)
 *
 * Registered in XOL-209 PR 3:
 *   request  — RequestDetailLayer (cascade drawer from /requests/<typeSlug>)
 *
 * Future entities (sharer, ticket) slot in here + a matching schema entry,
 * with no other code changes.
 */

import SiteDetailLayer from '@/components/tables/details/SiteDetailLayer'
import SiteUtilTable from '@/components/sites/utility/SiteUtilTable'
import SiteUtilBillDetail from '@/components/sites/utility/SiteUtilBillDetail'
import RequestDetailLayer from '@/components/tables/details/RequestDetailLayer'

import { drawerSchema, isKnownDrawer } from '@/lib/drawerSchema'

export { drawerSchema, isKnownDrawer }

export const drawerRegistry = Object.freeze({
  site: {
    component: SiteDetailLayer,
    propsFor: function (a) {
      return { siteId: a.id, tab: a.tab || null, subtab: a.subtab || null, subsubtab: a.subsubtab || null }
    }
  },
  siteUtil: {
    component: SiteUtilTable,
    propsFor: function (a) {
      // SiteUtilTable expects `utilityId` (the site id, named for historical
      // reasons) — see SiteUtilTable.vue props block. tab/subtab are not
      // consumed today but forwarded for future internal-tab routing.
      return { utilityId: a.id, tab: a.tab || null, subtab: a.subtab || null }
    }
  },
  bill: {
    component: SiteUtilBillDetail,
    propsFor: function (a) {
      return { billId: a.id, tab: a.tab || null, subtab: a.subtab || null }
    }
  },
  request: {
    component: RequestDetailLayer,
    propsFor: function (a) {
      return { actionId: a.id, tab: a.tab || null, subtab: a.subtab || null }
    }
  }
})
